import {
  TACAccountVerifyResource,
  TACCoursesResource,
  TACBookCourseResource,
} from "./resources";

export function getAllCourses({ from, to }) {
  return new Promise((resolve, reject) => {
    TACCoursesResource.get({ from, to }).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function postAccountVerify(payload) {
  return new Promise((resolve, reject) => {
    TACAccountVerifyResource.save({}, payload).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

export function bookCourse({ courseId, numberOfPersons }) {
  return new Promise((resolve, reject) => {
    TACBookCourseResource.save(
      {},
      { bookingId: courseId, numberOfPersons }
    ).then(
      (response) => {
        resolve(response.body);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
